.svg {
  display: block;
}

.jordskifterett,
.lagmannsrett,
.tingrett {
  transform-origin: center;
  transform-box: fill-box;
  animation-duration: 3.4s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

.jordskifterett {
  animation-name: jordskifterett;
}

.tingrett {
  animation-name: tingrett;
}

.lagmannsrett {
  animation-name: lagmannsrett;
}

@keyframes jordskifterett {
  0% {
    transform: scale(0.01);
  }

  16.66% {
    transform: scale(1);
  }

  33.33% {
    transform: scale(0.1);
  }

  50% {
    transform: scale(0.01);
  }

  66.66% {
    transform: scale(0.01);
  }

  83.33% {
    transform: scale(0.01);
  }

  100% {
    transform: scale(0.01);
  }
}

@keyframes tingrett {
  0% {
    transform: scale(0.01);
  }

  16.66% {
    transform: scale(0.01);
  }

  33.33% {
    transform: scale(0.01);
  }

  50% {
    transform: scale(1);
  }

  66.66% {
    transform: scale(0.1);
  }

  83.33% {
    transform: scale(0.01);
  }

  100% {
    transform: scale(0.01);
  }
}

@keyframes lagmannsrett {
  0% {
    transform: scale(0.01);
  }

  16.66% {
    transform: scale(0.01);
  }

  33.33% {
    transform: scale(0.01);
  }

  50% {
    transform: scale(0.01);
  }

  66.66% {
    transform: scale(0.01);
  }

  83.33% {
    transform: scale(1);
  }

  100% {
    transform: scale(0.1);
  }
}
